<template>

    <v-layout>
        <v-text-field
              type="number"
              @keyup="triggerKeyEvent(fieldtype, myFieldTypeValue)"
              :tabindex="tabindex"
              v-model="myFieldTypeValue"
              class="myOutlineTextField"
              box
              :append-icon="'icon-euro_symbol'"
        >
            <div slot="label">{{ label }}</div>
        </v-text-field>

        <v-menu :disabled="myFieldTypeValue.length === 0" bottom left transition="slide-y-transition">
            <v-btn
                :disabled="myFieldTypeValue.length === 0"
                class="mt-2 mr-0"
                slot="activator"
                icon
            >
                <v-icon class="icon-more_vert"></v-icon>
            </v-btn>

            <v-list>
                <v-list-tile @click="copyToClipboard(fieldtype)">
                    <v-list-tile-title><v-icon class="mr-3 icon-content_copy"></v-icon>In Zwischenablage kopieren</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>

    </v-layout>

</template>

<script>

export default {
    name: 'NumberField',
    props: {
        label: {
            type: String
        },
        fieldtype: {
            type: String
        },
        tabindex: {
            type: Number
        }
    },
    /*filters: {
      makeBetragCaption: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1) + '-Betrag'
      }
    },*/
    computed: {
        myFieldTypeValue: {
            set: function(val) {
                /*if ( val === '' ) {
                    val = 0;
                }*/
                this.$store.dispatch(this.fieldtype, val);
            },
            get() {
                return this.$store.getters[this.fieldtype];
            }
        }
    },
    methods: {
        triggerKeyEvent(fieldtype, el) {

            this.$emit("changedField", { typ: fieldtype, value: el });

        },
        copyToClipboard(value) {

            value = this.$store.getters[value];

            let container = this.$refs.container
            this.$copyText(value, container)

            this.$EventBus.$emit("showSnackbar", { text: 'Betrag wurde in die Zwischenablage kopiert.', status: 'info' });
        },
    }
}
</script>

<style scoped>

</style>
